<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.00065 1.33333C4.32065 1.33333 1.33398 4.31999 1.33398 7.99999C1.33398 11.68 4.32065 14.6667 8.00065 14.6667C11.6807 14.6667 14.6673 11.68 14.6673 7.99999C14.6673 4.31999 11.6807 1.33333 8.00065 1.33333ZM8.00065 11.3333C7.63398 11.3333 7.33398 11.0333 7.33398 10.6667V7.99999C7.33398 7.63333 7.63398 7.33333 8.00065 7.33333C8.36732 7.33333 8.66732 7.63333 8.66732 7.99999V10.6667C8.66732 11.0333 8.36732 11.3333 8.00065 11.3333ZM8.66732 5.99999H7.33398V4.66666H8.66732V5.99999Z"
      fill="#3273F6"
    />
  </svg>
</template>
